<template>
  <div class="pwmat-introduce-background">
    <div class="pwmat-introduce-banner">
      <div class="pwmat-introduce-container">
        <div class="pwmat-introduce-banner-title">LS3DF</div>
      </div>

      <img
        class="pwmat-introduce-banner-img"
        src="../../assets/about/banner.png"
      />
    </div>
    <div class="pwmat-introduce-container">
      <div class="pwmat-introduce-content">
        <div class="pwmat-introduce-content-title">
          <div class="pwmat-introduce-content-title-text">{{ $t("p_ls3df.title") }}</div>
          <div class="pwamt-introduce-line"></div>
        </div>
        <div class="pwmat-introduce-content-info">
          <p class="pwmat-introduce-content-info-text">{{ $t("p_ls3df.titleP1") }}</p>
          <p class="pwmat-introduce-content-info-text">{{ $t("p_ls3df.titleP2") }}</p>
        </div>

        <div class="pwmat-introduce-content-title" style="padding-top: 20px">
          <div class="pwmat-introduce-content-title-text">{{ $t("p_ls3df.ls3dfT1") }}</div>
          <div class="pwamt-introduce-line"></div>
        </div>

        <div class="pwmat-introduce-content-info">
          <p
            class="pwmat-introduce-content-info-text"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
          >
          {{ $t("p_ls3df.ls3dfT1P1") }}：<a href="//www.pwmat.com/ls3df-download"
              >//www.pwmat.com/ls3df-download</a
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PWMAT_RESOURCE } from "./../../helpers/consts";
export default {
  name: "companyIntroduce",
  data() {
    return {
      PWMAT_RESOURCE,
    };
  },
  methods: {
    toMSTATIONDownload() {
      this.$router.push({ name: "MSTATIONDownload" });
    },
    toPotentialDownload() {
      this.$router.push({ name: "PotentialDownload" });
    },
    toModuleDownload() {
      this.$router.push({ name: "ModuleDownload" });
    },
    toManual() {
      window.open(this.PWMAT_RESOURCE + "Manual.pdf");
    },
    toProchureBook() {
      window.open(this.PWMAT_RESOURCE + "prochure.pdf");
    },
    toProchureNewFunctions() {
      window.open(this.PWMAT_RESOURCE + "PWmat_2019_new_functions.pdf");
    },
  },
};
</script>

<style scoped>
.pwmat-introduce-container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.pwmat-introduce-background {
  margin-top: 70px;
}
.pwmat-introduce-banner {
  overflow: hidden;
}
.pwmat-introduce-banner-title {
  font-size: 24px;
  font-family: PingFangSC-Semibold, sans-serif;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 50px;
  position: absolute;
  margin-top: 60px;
}
.pwmat-introduce-banner-img {
  min-width: 100%;
  height: 165px;
}
.pwmat-introduce-content {
  margin-top: 30px;
  margin-bottom: 90px;
}
.pwmat-introduce-content-title {
  padding-top: 50px;
}
.pwmat-introduce-content-title-text {
  font-size: 30px;
  font-family: PingFangSC-Medium, sans-serif;
  font-weight: 500;
  color: rgba(73, 145, 201, 1);
  line-height: 50px;
}
.pwmat-introduce-content-info {
  margin-top: 40px;
}
.pwmat-introduce-content-info-text {
  font-size: 16px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(79, 76, 77, 1);
  line-height: 25px;
}
.pwamt-introduce-line {
  height: 1px;
  background: rgba(240, 240, 240, 1);
  margin-top: 8px;
}
.pwmat-introduce-function {
  display: inline-block;
  padding-left: 80px;
  margin-bottom: 50px;
  width: 346px;
}
.pwmat-introduce-function-img {
  display: inline-block;
  vertical-align: top;
}
.pwmat-introduce-function-text {
  display: inline-block;
  vertical-align: top;
  margin-left: 23px;
}
.pwmat-introduce-function-name {
  font-size: 18px;
  font-family: PingFangSC-Medium, sans-serif;
  font-weight: 500;
  color: rgba(79, 76, 77, 1);
  line-height: 25px;
  margin-bottom: 8px;
  margin-top: -6px;
}
.pwmat-introduce-function-desc {
  font-size: 14px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(79, 76, 77, 1);
  line-height: 20px;
}
.pwmat-inroduce-application {
  background: rgba(73, 145, 201, 0.1);
  padding: 24px 99px 27px 99px;
  margin-bottom: 50px;
}
.pwmat-inroduce-application-group-1 {
  width: 539px;
  display: inline-block;
}
.pwmat-inroduce-application-group-2 {
  width: 299px;
  display: inline-block;
}
.pwmat-inroduce-application-text {
  font-size: 16px;
  font-family: PingFangSC-Medium, sans-serif;
  font-weight: 500;
  color: rgba(79, 76, 77, 1);
  line-height: 38px;
  margin-bottom: 0;
}
@media screen and (max-width: 482px) {
  .pwmat-introduce-container {
    max-width: 100%;
  }
}
@media screen and (min-width: 482px) and (max-width: 768px) {
  .pwmat-introduce-container {
    max-width: 450px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1100px) {
  .pwmat-introduce-container {
    max-width: 736px;
  }
}
@media screen and (min-width: 1100px) and (max-width: 1444px) {
  .pwmat-introduce-container {
    max-width: 1068px;
  }
}
@media screen and (min-width: 1444px) {
  .pwmat-introduce-container {
    max-width: 1068px;
  }
}
</style>
